module.exports = __webpack_public_path__ + "static/media/jumbo2.7aecab31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Jumbotron/images/jumbo2.jpg
// module id = 428
// module chunks = 0